import {Dispatcher} from "../../../stem-core/src/base/Dispatcher.js";
import {NOOP_FUNCTION} from "../../../stem-core/src/base/Utils.js";
import {Router} from "../../../stem-core/src/ui/Router.jsx";
import {ADDRESS_PANEL_URL} from "../PanelConstants.js";


export class AddressController extends Dispatcher {
    addressSectionState = null;
    selectedAddress = null;
    continueLabel = ""; // TODO @branch WTF is this?
    onSelectSuccess = NOOP_FUNCTION; // TODO @branch just use async something

    constructor(options={}) {
        super(options);
        this.update(options);
    }

    update(props) {
        Object.assign(this, props);
        this.dispatch();
    }

    async collectAddress() {
        return new Promise((resolve) => {
            this.onSelectSuccess = () => resolve(this.selectedAddress);
            Router.changeURL(ADDRESS_PANEL_URL);
        });
    }
}
